import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setList: (state, list) => {
    if (isEmpty(state.list)) {
      state.list = list;
    } else {
      state.list = [...state.list, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
    state.condition.searchType = 'ISSUED';
    state.list = [];
  }
};
